import React from 'react';
import PropTypes from 'prop-types';

import { studentGradesType } from '../../types';

import { GradeBox } from './ExportGradesColumn.styled';
import OverrideMenu from '$components/OverrideMenu';

const ExportGradesColumn = ({
  studentGrades,
  updateStudentOverride,
  hasGradeOverride,
}) =>
  studentGrades.map(({ selectedOverrideValue, overrideOptions, studentId }) => (
    <GradeBox key={studentId}>
      <OverrideMenu
        value={selectedOverrideValue}
        options={overrideOptions}
        onChange={updateStudentOverride(studentId)}
        hasGradeOverride={hasGradeOverride}
      />
    </GradeBox>
  ));

ExportGradesColumn.propTypes = {
  studentGrades: PropTypes.arrayOf(studentGradesType).isRequired,
  updateStudentOverride: PropTypes.func.isRequired,
  hasGradeOverride: PropTypes.bool.isRequired,
};

export default ExportGradesColumn;
